module.exports = __webpack_public_path__ + "static/media/lv.9243ae82.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/lv.svg
// module id = 2146
// module chunks = 0